import { Injectable } from '@angular/core';
import { ChordProParser, HtmlDivFormatter, Song } from 'chordsheetjs';

@Injectable({
  providedIn: 'root'
})
export class ChordService {
  private parser = new ChordProParser();
  private formatter = new HtmlDivFormatter();

  // We return the Song object so the component can manipulate it
  getSongObject(chordProText: string) {
    try {
      return this.parser.parse(chordProText);
    } catch (error) {
      console.error('Failed to parse ChordPro text:', error);
      return null; // Return null to indicate failure
    }
  }

  renderSong(song: Song, transposeSteps: number = 0): string {
    // Clone the song so we don't permanently mutate the original object
    const transposedSong = song.transpose(transposeSteps);
    return this.formatter.format(transposedSong);
  }
}
